import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import InvestmentConfirmationModal from '../../../../../components/common/modals/InvestmentConfirmationModal';
import { useNavigateByName } from '../../../../../hooks';
import { RouteDictionary } from '../../../../../utils';

const InvestmentConfirmation = () => {
  const { uuid, confirmationUuid } = useParams();
  const navigate = useNavigateByName();
  const location = useLocation();

  if (!uuid || !confirmationUuid) {
    return null;
  }

  const handleClose = () => {
    if (location.pathname.includes('/confirmation/')) {
      navigate(RouteDictionary.DETAILED_PROJECT, { uuid });
    }
  };

  return (
    <InvestmentConfirmationModal active confirmationUuid={confirmationUuid} onClose={handleClose} />
  );
};

export default InvestmentConfirmation;
